// extracted by mini-css-extract-plugin
export default {"root":"RelatedUnitLessonContent-module--root--5dc6a","card":"RelatedUnitLessonContent-module--card--70f3b"};